// extracted by mini-css-extract-plugin
export default {"modalcoming":"modalcoming_modalcoming__WmIRF","closemodal":"modalcoming_closemodal__1gi2t","modalcoming__main":"modalcoming_modalcoming__main__obfbg"};